var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThermostat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8404_44345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8 13.1V4.3C15.8 2.474 14.326 1 12.5 1C10.674 1 9.2 2.474 9.2 4.3V13.1C7.869 14.101 7 15.707 7 17.5C7 20.536 9.464 23 12.5 23C15.536 23 18 20.536 18 17.5C18 15.707 17.131 14.101 15.8 13.1ZM11.4 4.3C11.4 3.695 11.895 3.2 12.5 3.2C13.105 3.2 13.6 3.695 13.6 4.3H12.5V5.4H13.6V7.6H12.5V8.7H13.6V10.9H11.4V4.3Z",
    fill: "#263668"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8404_44345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermostat);
export default __webpack_public_path__ + "static/media/thermostat.5e13eea3fcd451c9f68a9aca5d663c08.svg";
export { ForwardRef as ReactComponent };